import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export default function AuthGuard(props) {
  const auth = window.sessionStorage.getItem('User') ? true : false;
  return(
     auth ? <Outlet/> : <Navigate to="/"/>
  )
}
